// ============================================================================
// SWAHILI TRANSLATIONS - CHAPTER 1: MWANZO
// ============================================================================
// Viwango 1-13 (viwango 13, maswali 39)

export const chapter1Translations = {
  name: "Mwanzo",
  description: "Hapo mwanzo... Maarifa huruhusu roho kuwa hai",
  
  spiritualWisdom: {
    principle: "Maarifa huruhusu roho kuwa hai",
    scripture: "Watu wangu wanaangamia kwa kukosa maarifa (Hosea 4:6)",
    application: "Kila aya iliyosomwa, kila ukweli uliogundulika huilisha roho yetu na kuimarisha imani yetu"
  },
  
  levels: {
    1: {
      name: "Uumbaji",
      challenge: "Hapo mwanzo Mungu aliumba mbingu na nchi...",
      easy: {
        question: "Mungu aliumba ulimwengu katika siku ngapi?",
        options: ["Siku 5", "Siku 6", "Siku 7", "Siku 8"],
        hint: "Fikiria siku ya kupumzika katika wiki",
        funFact: "💡 Siku ya 7, Mungu alipumzika. Huu ndio chanzo cha Sabato, siku ya kupumzika ya kila wiki!"
      },
      medium: {
        question: "Mungu aliumba nini siku ya nne?",
        options: ["Wanyama", "Mwanadamu", "Jua, mwezi na nyota", "Mimea"],
        hint: "Viumbe hivi vinaangaza dunia na kuonyesha wakati",
        funFact: "🌟 Mianga iliumbwa kuonyesha majira na sikukuu za kidini!"
      },
      hard: {
        question: "Maana yake nini kuwa mwanadamu aliumbwa 'kwa sura ya Mungu'?",
        options: [
          "Mwonekano wa kimwili sawa",
          "Uwezo wa kuumba na kupenda",
          "Uzima wa milele wa asili",
          "Nguvu za kimungu"
        ],
        hint: "Inahusu sifa za kiroho na kiakili",
        funFact: "✨ Sura ya Mungu ndani yetu inajumuisha ubunifu, dhamiri na uwezo wa kupenda!"
      }
    },
    
    2: {
      name: "Majaribu ya Bustanini",
      challenge: "Nyoka alikuwa mjanja zaidi kuliko wanyama wote...",
      easy: {
        question: "Mnyama gani alimjaribu Hawa bustanini?",
        options: ["Simba", "Nyoka", "Tai", "Joka"],
        hint: "Mnyama huyu hutambaa tumboni",
        funFact: "🐍 Nyoka unawakilisha majaribu na ujanja katika Biblia yote!"
      },
      medium: {
        question: "Nyoka alimwahidi Hawa nini cha uwongo?",
        options: [
          "Mtakuwa wasio na kifo",
          "Mtakuwa matajiri",
          "Mtakuwa kama miungu",
          "Mtakuwa na furaha"
        ],
        hint: "Nyoka anaahidi kuinuliwa hadi kiwango cha kimungu",
        funFact: "🎭 Uongo wa nyoka unachanganya ukweli na udanganyifu - mbinu ya kawaida ya majaribu!"
      },
      hard: {
        question: "Anguko hili linaelezaje mapambano yetu kati ya wema na ubaya?",
        options: [
          "Ubaya ni wenye nguvu zaidi",
          "Uhuru wa kuchagua unamaanisha uwajibikaji",
          "Mungu anatuacha",
          "Majaribu hayashindiki"
        ],
        hint: "Inahusu uwezo wetu wa kuchagua na kukubali matokeo",
        funFact: "🌳 Mti wa maarifa unasimboliza uchaguzi wa kimaadili unaofafanua ubinadamu!"
      }
    },
    
    3: {
      name: "Kaini na Abeli",
      challenge: "Ndugu wawili, sadaka mbili, mrama wa milele...",
      easy: {
        question: "Nani alikuwa muuaji wa kwanza katika historia ya Biblia?",
        options: ["Abeli", "Sethi", "Kaini", "Adamu"],
        hint: "Ndugu mwenye wivu wa Abeli",
        funFact: "⚡ Kaini anakuwa ishara ya wivu wa kuharibu wa kindugu!"
      },
      medium: {
        question: "Kwa nini Mungu alipendelea sadaka ya Abeli?",
        options: [
          "Wingi zaidi",
          "Abeli alikuwa mzuri zaidi",
          "Ilitolewa kwa moyo wa kweli",
          "Ilikuwa nyama"
        ],
        hint: "Mungu anaangalia moyo",
        funFact: "❤️ Mungu anaangalia moyo, si mwonekano wa matendo yetu tu!"
      },
      hard: {
        question: "Historia hii inafundisha nini kuhusu wivu?",
        options: [
          "Wivu ni wa asili",
          "Wivu usiodhibitiwa husababisha uharibifu",
          "Mungu anapendelea wengine",
          "Ushindani ni mzuri",
          "Kushindana ni afya"
        ],
        hint: "Inahusu matokeo ya kutodhibiti hisia zetu",
        funFact: "🔥 'Dhambi iko mlangoni' - Mungu anataonya kabla ya kuanguka!"
      }
    },

    4: {
      name: "Gharika ya Noa",
      challenge: "Mvua ikanyesha juu ya nchi kwa siku arobaini usiku na mchana...",
      easy: {
        question: "Mvua ya gharika ilidumu siku na usiku ngapi?",
        options: ["Siku 30", "Siku 40", "Siku 50", "Siku 100"],
        hint: "Nambari ya ishara katika Biblia",
        funFact: "☔ Nambari 40 inasimboliza majaribio na mabadiliko katika Biblia!"
      },
      medium: {
        question: "Noa alipaswa kuchukua wanyama safi wangapi katika safina?",
        options: [
          "Jozi 1",
          "Jozi 2",
          "Jozi 7",
          "Jozi 10"
        ],
        hint: "Zaidi ya wanyama wasio safi",
        funFact: "🦁 Wanyama safi walikuwa kwa ajili ya dhabihu baada ya gharika!"
      },
      hard: {
        question: "Safina inasimboliza nini katika safari yetu ya kiroho?",
        options: [
          "Kukimbia mbele ya matatizo",
          "Wokovu kupitia imani na utii",
          "Kutengwa muhimu",
          "Ubora wa waumini"
        ],
        hint: "Inahusu wokovu unaotolewa kwa wale wanaoamini",
        funFact: "🚢 Safina inatangulia wokovu: njia moja ya kuepuka hukumu!"
      }
    },

    5: {
      name: "Mnara wa Babeli",
      challenge: "Tujijengee mnara ambao kilele chake kitafika mbinguni...",
      easy: {
        question: "Mungu alichanganya nini huko Babeli?",
        options: ["Mipango", "Lugha", "Zana", "Mawazo"],
        hint: "Kinachoruhusu kuwasiliana",
        funFact: "🗣️ Babeli ni chanzo cha hadithi cha utofauti wa lugha ulimwenguni!"
      },
      medium: {
        question: "Kwa nini watu walitaka kujenga mnara huu?",
        options: [
          "Kujilinda",
          "Kuishi pamoja",
          "Kujifanyia jina na kufikia mbinguni",
          "Kumheshimu Mungu"
        ],
        hint: "Inahusu kiburi na kutaka kulingana na Mungu",
        funFact: "🏗️ Kiburi cha kutaka kulingana na Mungu daima husababisha mkanganyiko!"
      },
      hard: {
        question: "Kiburi cha Babeli kinaonekana vipi leo?",
        options: [
          "Katika teknolojia tu",
          "Katika nia ya kibinadamu ya kujitegemea kabisa bila Mungu",
          "Katika majengo marefu",
          "Katika lugha tofauti"
        ],
        hint: "Inahusu kutaka kuishi bila Mungu",
        funFact: "💭 Babeli inatukumbusha kuwa umoja bila Mungu unakuwa kiburi cha kuharibu!"
      }
    },

    6: {
      name: "Wito wa Abrahamu",
      challenge: "Ondoka nchi yako, jamaa yako na nyumba ya baba yako...",
      easy: {
        question: "Abrahamu alikuwa na umri gani alipoondoka nchi yake?",
        options: ["Miaka 50", "Miaka 65", "Miaka 75", "Miaka 100"],
        hint: "Umri mkubwa sana wa kuanza upya",
        funFact: "🚶 Kwa miaka 75, Abrahamu anaanza maisha mapya - haijachelewa kamwe!"
      },
      medium: {
        question: "Ahadi tatu gani Mungu alimpa Abrahamu?",
        options: [
          "Utajiri, nguvu, hekima",
          "Nchi, wazao, baraka ya ulimwengu",
          "Maisha marefu, amani, mafanikio",
          "Imani, tumaini, upendo"
        ],
        hint: "Ahadi inayohusu wanadamu wote",
        funFact: "🌟 Ahadi kwa Abrahamu inahusu wanadamu wote, si yeye tu!"
      },
      hard: {
        question: "'Kuruka kwa imani' kwa Abrahamu kunafundisha nini?",
        options: [
          "Imani ya kipofu ni hatari",
          "Kumfuata Mungu kunahitaji kuacha usalama wetu",
          "Mungu anapendelea mataifa fulani",
          "Imani inahakikisha mafanikio"
        ],
        hint: "Inahusu kumwamini huku tukiacha alama zetu",
        funFact: "✨ Abrahamu anaitwa 'baba wa imani' kwa sababu aliamini bila kuona!"
      }
    },

    7: {
      name: "Dhabihu ya Isaka",
      challenge: "Mchukue mwanao, pekee wako, unayempenda...",
      easy: {
        question: "Abrahamu alipaswa kumtoa Isaka dhabihu kwenye mlima upi?",
        options: ["Sinai", "Moria", "Karmeli", "Sayuni"],
        hint: "Mlima huu utakuwa mahali patakatifu",
        funFact: "🏔️ Mlima Moria utakuwa mahali pa Hekalu la Yerusalemu!"
      },
      medium: {
        question: "Mungu alitoa nini badala ya Isaka?",
        options: [
          "Mwana-kondoo",
          "Kondoo dume aliyeshikwa kwa pembe",
          "Mbuzi",
          "Ng'ombe"
        ],
        hint: "Mnyama dume mzima mwenye pembe",
        funFact: "🐏 Kondoo aliyebadilishwa anatangulia dhabihu mbadala ya mwisho!"
      },
      hard: {
        question: "Majaribio haya yanaonyesha vipi imani kamili?",
        options: [
          "Mungu anajaribu kwa ukatili",
          "Imani inazidi hata upendo wa kiabaa",
          "Dhabihu za wanadamu zinapendeza Mungu",
          "Abrahamu hakumpenda Isaka kweli"
        ],
        hint: "Inahusu kumwamini hata tunaposhindwa kuelewa",
        funFact: "💝 Mungu daima hutoa njia pipa tunapomwamini!"
      }
    },

    8: {
      name: "Yakobo na Esau",
      challenge: "Mdogo atatumikia mkubwa...",
      easy: {
        question: "Esau aliuza haki yake ya mzaliwa wa kwanza kwa nini?",
        options: ["Dhahabu", "Sahani ya dengu", "Nguo", "Divai"],
        hint: "Chakula cha kutosheleza njaa",
        funFact: "🍲 Wakati wa njaa ulimgharimu Esau baraka ya milele!"
      },
      medium: {
        question: "Yakobo alimdanganya vipi baba yake Isaka?",
        options: [
          "Kwa kubadilisha sauti",
          "Kwa kujivisha",
          "Kwa kujifunika ngozi ya mbuzi",
          "Kwa kusema uongo kuhusu jina lake"
        ],
        hint: "Ili kufanana na ndugu yake mwenye nywele nyingi",
        funFact: "🎭 Isaka, kipofu, alitambua harufu na mguso lakini si udanganyifu!"
      },
      hard: {
        question: "Historia hii inafunua nini kuhusu uchaguzi wetu?",
        options: [
          "Udanganyifu ni muhimu wakati mwingine",
          "Matamanio ya papo hapo yanaweza kugharimu hatima yetu",
          "Mungu anakubali ujanja",
          "Mdogo daima anapendelewa"
        ],
        hint: "Inahusu matokeo ya maamuzi yetu ya haraka",
        funFact: "⚖️ Uchaguzi wetu wa haraka unaweza kuwa na matokeo ya milele!"
      }
    },

    9: {
      name: "Ndoto ya Yakobo",
      challenge: "Akaona ngazi iliyowekwa ardhini, na kilele chake kikifikia mbinguni...",
      easy: {
        question: "Yakobo aliona nini katika ndoto yake?",
        options: [
          "Mti mkubwa",
          "Ngazi ya kwenda mbinguni na malaika",
          "Hekalu",
          "Nyota"
        ],
        hint: "Njia ya mawasiliano kati ya mbingu na dunia",
        funFact: "👼 Ngazi ya Yakobo inasimboliza muunganisho kati ya Mbingu na Dunia!"
      },
      medium: {
        question: "Yakobo alifanya nini na jiwe alilosimia?",
        options: [
          "Alivunja",
          "Alizika",
          "Aliusimamisha na kuupaka mafuta",
          "Aliuchukua"
        ],
        hint: "Alifanya kumbukumbu takatifu",
        funFact: "🪨 Jiwe hili linakuwa 'Betheli' - nyumba ya Mungu!"
      },
      hard: {
        question: "Maono haya yanaunganisha vipi mbingu na dunia katika maisha yetu?",
        options: [
          "Kupitia ndoto tu",
          "Kupitia maombi yanayoweka daraja na kimungu",
          "Kupitia malaika walinzi",
          "Kupitia maeneo matakatifu"
        ],
        hint: "Inahusu mawasiliano yetu na Mungu",
        funFact: "🌉 Maombi ni ngazi yetu binafsi kuelekea Mbinguni!"
      }
    },

    10: {
      name: "Yusufu Aliuzwa na Ndugu Zake",
      challenge: "Tazama, mwota ndoto anakuja...",
      easy: {
        question: "Yusufu alikuwa na ndugu wangapi?",
        options: ["Ndugu 7", "Ndugu 10", "Ndugu 11", "Ndugu 12"],
        hint: "Mmoja chini ya idadi ya makabila ya Israeli",
        funFact: "👨‍👨‍👦‍👦 Wana 12 wa Yakobo watakuwa makabila 12 ya Israeli!"
      },
      medium: {
        question: "Yusufu aliuzwa kwa fedha ngapi?",
        options: [
          "Fedha 10",
          "Fedha 20",
          "Fedha 30",
          "Fedha 50"
        ],
        hint: "Bei ya mtumwa",
        funFact: "💰 Fedha 20, bei ya mtumwa wakati huo!"
      },
      hard: {
        question: "Wivu unavyokuwa chombo cha mpango wa Mungu?",
        options: [
          "Mungu anakubali wivu",
          "Ubaya unageuzwa kuwa wema na Mungu",
          "Wivu ni muhimu",
          "Ndugu walikuwa sahihi"
        ],
        hint: "Inahusu upatikanaji wa Mungu unaobadilisha ubaya",
        funFact: "🎨 Mungu anageuza hata matendo yetu mabaya zaidi kuwa kazi bora za neema!"
      }
    },

    11: {
      name: "Yusufu Gerezani",
      challenge: "Bwana alikuwa pamoja na Yusufu na akamtendea wema...",
      easy: {
        question: "Yusufu alikuwa na kipawa gani maalum?",
        options: [
          "Kutabiri",
          "Kufasiri ndoto",
          "Kuponya wagonjwa",
          "Kusema na wanyama"
        ],
        hint: "Uwezo unaohusiana na ndoto",
        funFact: "💭 Ndoto zilizingatiwa kuwa ujumbe wa kimungu katika kale!"
      },
      medium: {
        question: "Watumishi gani wa Farao walikuwa gerezani pamoja na Yusufu?",
        options: [
          "Waziri na mwandishi",
          "Mnyweshaji na mwokaji",
          "Daktari na mlinzi",
          "Mpishi na bustani"
        ],
        hint: "Aliyetumikia divai na aliyetumikia mkate",
        funFact: "🍷 Mnyweshaji alionja divai ya mfalme kuepuka sumu!"
      },
      hard: {
        question: "Yusufu anafundisha nini kuhusu uaminifu katika taabu?",
        options: [
          "Udhalimu ni wa kukubalika",
          "Uaminifu kwa Mungu unazidi hali",
          "Gereza hubadilisha watu",
          "Lazima kulipiza kisasi"
        ],
        hint: "Inahusu kubaki mwaminifu hata katika majaribu",
        funFact: "⭐ Hata gerezani, Yusufu alibaki mwadilifu na Mungu akamtukuza!"
      }
    },

    12: {
      name: "Ndoto za Farao",
      challenge: "Ng'ombe saba wanene... ng'ombe saba waliokonda...",
      easy: {
        question: "Ng'ombe wangapi waliokonda waliwala ng'ombe wanene?",
        options: ["5", "6", "7", "8"],
        hint: "Nambari kamili",
        funFact: "🐄 Nambari 7 inasimboliza ukamilifu katika Biblia!"
      },
      medium: {
        question: "Miaka 7 katika ndoto ilimaanisha nini?",
        options: [
          "Miaka 7 ya vita kisha amani",
          "Miaka 7 ya wingi kisha miaka 7 ya njaa",
          "Miaka 7 ya ugonjwa kisha afya",
          "Miaka 7 ya mvua kisha ukame"
        ],
        hint: "Mzunguko wa wingi na upungufu",
        funFact: "🌾 Yusufu aliokoa Misri na familia yake kwa ufafanuzi huu!"
      },
      hard: {
        question: "Hekima ya kimungu inabadilisha vipi mihadhara?",
        options: [
          "Kwa kuepuka mihadhara yote",
          "Kwa kutoa busara ya kujiandaa",
          "Kwa kuadhibu waovu",
          "Kwa kutajirisha waumini"
        ],
        hint: "Inahusu maandalizi na utabiri",
        funFact: "💡 Hekima ya kimungu inageuza mihadhara kuwa fursa za wokovu!"
      }
    },

    13: {
      name: "Upatanisho wa Ndugu",
      challenge: "Mimi ni Yusufu, ndugu yenu mliyeniuza...",
      easy: {
        question: "Yusufu aliweka nini katika mfuko wa Benjamini?",
        options: [
          "Dhahabu",
          "Pete yake",
          "Kikombe chake cha fedha",
          "Barua"
        ],
        hint: "Kitu cha thamani cha kibinafsi",
        funFact: "🏆 Kikombe kilitumika pia 'kusoma' mustakabali katika maji!"
      },
      medium: {
        question: "Yusufu alisema neno gani maarufu kuhusu ubaya uliobadilishwa?",
        options: [
          "Nawasamehe",
          "Mlikusudia ubaya, Mungu aliubadilisha kuwa wema",
          "Tusahau yaliyopita",
          "Kisasi ni cha Mungu"
        ],
        hint: "Sentensi kuhusu upatikanaji wa Mungu",
        funFact: "✨ Sentensi hii inafupisha upatikanaji wa Mungu wote katika maisha yetu!"
      },
      hard: {
        question: "Msamaha unavyovunja mizunguko ya kisasi?",
        options: [
          "Kwa kusahau ubaya",
          "Kwa kumwachilia mkosaji na aliyekosewa kwa mwanzo mpya",
          "Kwa kuadhibu kwanza",
          "Kwa kuweka umbali"
        ],
        hint: "Inahusu ukombozi wa pande zote",
        funFact: "🕊️ Msamaha wa Yusufu unatangulia msamaha wa kimungu wa ulimwengu!"
      }
    }
  }
};

export default chapter1Translations;
